import { Molecule, wrap } from 'AppReact';
import styled from 'styled-components';
import { SecondaryTextSm, SecondaryTextSm400, Icon } from 'atoms';
import { Mr2 } from 'wrappers';

const template = styled.a`
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

export default Molecule({
  template,
  type: 'link',
  atoms: [
    {
      component: wrap(Icon, Mr2),
      name: 'Icon',
      displayValue: ({ icon }) => icon
    },
    {
      component: wrap(SecondaryTextSm400, Mr2),
      name: 'Key',
      displayValue: ({ label }) => label
    },
    {
      component: SecondaryTextSm,
      name: 'Value',
      displayValue: ({ value }) => value,
    },
  ]
})